import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getAllVoucherAction = createAsyncThunk(
    'get-all-Vouchers',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/fetch-topupx`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAllVoucherSlice = createSlice({
    name: 'get-all-Vouchers',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllVoucherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAllVoucherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getAllVoucherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getAllVoucherReducer = getAllVoucherSlice.reducer